import Immutable from 'seamless-immutable';
import { createReducer } from 'redux-act';
import Actions from './actions';

const Reducer = {
  rootReducer: createReducer(
    {
      [Actions.showModule]: (state, { moduleId }) => state.setIn([moduleId, 'isVisible'], true),
      [Actions.hideModule]: (state, { moduleId }) => state.setIn([moduleId, 'isVisible'], false),
    },
    Immutable({})
  ),
};

export default Reducer;
